import * as React from 'react';
import { Flex, InfoIcon, SiteVariablesPrepared } from "@fluentui/react-northstar";

export function ChartErrorState({
  siteVariables,
}: {
  siteVariables: SiteVariablesPrepared;
}) {
  const textColor = siteVariables.colors.red["400"];
  const { t } = siteVariables;
  return (
    <Flex
      styles={{
        height: "100%",
        minHeight: "14rem",
        backgroundColor: siteVariables.colorScheme.grey.background,
        color: textColor,
      }}
      vAlign="center"
      hAlign="center"
    >
      <InfoIcon outline styles={{ marginRight: ".5rem" }} />{" "}
      {t["could not load data"]}
    </Flex>
  );
}
